import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import MyCollections from "./MyCollections";
import FavouritedPacksSidebar from "./FavouritedPacksSidebar";
import collectionStore from "../../stores/collectionStore";
import { useRouteMatch } from "react-router-dom";
import AddToCollection from "#images/add-to-collection.png";

@inject("authStore")
@observer
class MyItemsSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = { menu: "my_collections" };
  }

  switchToCollections = (e) => this.setState({ menu: "my_collections" });

  switchToPacks = (e) => this.setState({ menu: "packs" });

  get isPacksActive() {
    // always active on my collections page
    if (this.onMyCollectionsPage) return true;
    if (this.onFavouritesPage) return false;

    return this.state.menu === "packs";
  }

  get isMyCollectionsActive() {
    if (this.onFavouritesPage) return true;
    if (this.onMyCollectionsPage) return false;

    return this.state.menu === "my_collections";
  }

  get onMyCollectionsPage() {
    return useRouteMatch("/my-collections");
  }

  get onFavouritesPage() {
    return useRouteMatch("/products-favourited");
  }

  tabClass(active) {
    return active
      ? "underline underline-offset-[6px] decoration-orange-1 decoration-2"
      : "cursor-pointer";
  }

  render() {
    if (!this.props.authStore.isLoggedIn) return null;

    return (
      <>
        {!this.onMyCollectionsPage && (
          <p className="mb-5 text-[23px] font-bold leading-none">Collections</p>
        )}
        <div className="mb-5 flex items-center">
          {!this.onMyCollectionsPage && (
            <p
              onClick={this.switchToCollections}
              className={`h-fit text-[19px] font-bold leading-none tracking-tighter ${this.tabClass(this.isMyCollectionsActive)}`}
            >
              My Collections
            </p>
          )}

          {!this.onFavouritesPage && (
            <p
              onClick={this.switchToPacks}
              className={`h-fit text-[19px] font-bold leading-none tracking-tighter ${!this.onMyCollectionsPage ? "ml-4" : ""} ${this.tabClass(this.isPacksActive)}`}
            >
              Favourite Packs
            </p>
          )}

          {this.isMyCollectionsActive && (
            <div onClick={collectionStore.showCreateModal} className="ml-auto">
              <img
                src={AddToCollection}
                className="h-[24px] w-[24px] cursor-pointer"
              />
            </div>
          )}
        </div>
        {this.isMyCollectionsActive && <MyCollections />}
        {this.isPacksActive && <FavouritedPacksSidebar />}
      </>
    );
  }
}

export default MyItemsSidebar;
